export const EXCMREGIONUSERDATA_CREATE_RESET = 'EXCMREGIONUSERDATA_CREATE_RESET'
export const EXCMREGIONUSERDATA_CREATE_SET_CREATED = 'EXCMREGIONUSERDATA_CREATE_SET_CREATED'
export const EXCMREGIONUSERDATA_CREATE_SET_ERROR = 'EXCMREGIONUSERDATA_CREATE_SET_ERROR'
export const EXCMREGIONUSERDATA_CREATE_SET_VIOLATIONS = 'EXCMREGIONUSERDATA_CREATE_SET_VIOLATIONS'
export const EXCMREGIONUSERDATA_CREATE_TOGGLE_LOADING = 'EXCMREGIONUSERDATA_CREATE_TOGGLE_LOADING'
